// https://atlassian-2y.sentry.io/projects/search-page/getting-started
export const SENTRY_DSN =
	'https://dcf49f8a57e71c9e77d30808a7708f8c@o55978.ingest.us.sentry.io/4506951588773888';

export const UNKNOWN_TAG = 'unknown';

export const COMMON_TAGS = {
	search: true, // Used to filter out errors that are not from search projects
};
